<template>
    <div class="BrandResult">
        <div class="container">
            <div class="row" v-for="(item, index) in this.items" :key="index">
                <div class="text-white PageHeader">
                    <div class="PageHeader__title">
                        <div class="bg-white brand-head relative px-5 md:px-20 py-10 mt-10 mb-24">
                            <div class="flex justify-between py-5">
                                <div class="flex items-center">
                                    <span slot="preview" class="m-none text-right pr-6">
                                    <i class="fa fa-rss text-4xl leading-7 text-black"></i>
                                    </span>
                                    <div>
                                        <h2 class="uppercase text-black text-left">{{ item.campaign.name }}</h2>
                                        <h3>
                                            <p v-if="item.campaign_status === 'published'" style="color: #66DBA8;text-transform: uppercase;font-weight: 600;font-size: 16px;float: left;">Aktiv</p>

                                            <p v-else-if="item.campaign_status === 'expired'" style="color: #fc0403;text-transform: uppercase;font-weight: 600;font-size: 16px;float: left;">Udløbet</p>

                                            <p v-else-if="item.campaign_status === 'draft'" style="color: rgb(112, 112, 112);text-transform: uppercase;font-weight: 600;font-size: 16px;float: left;">Kladde</p>
                                        </h3>
                                    </div>
                                </div>
                                <div>

                                </div>
                                <div class="flex gap-3 items-center">
                                    <a href="javascript:void(0);" @click="toggleMenu(item.campaign.id)">
                                        <i v-if="!getToggleMenu(item.campaign.id)" class="fa fa-plus-circle text-4xl"></i>
                                        <i v-else class="fa fa-minus-circle text-4xl"></i>
                                    </a>
                                </div>
                            </div>
                            <hr style="border-top: 3px solid rgb(24, 37, 216);" />
                            <div class="flex my-6" v-show="getToggleMenu(item.campaign.id)">

                            </div>
                            <brand-result-info
                                v-if="!getToggleMenu(item.campaign.id)"
                                :title="getTitle(item.campaign)"
                                :campaign="item.campaign"
                                :insight="item.insight"
                                :image="null"
                                :isShowAll="true"
                                :is-show-tooltip="false"
                            />

                            <brand-result-info-detail
                                :campaign="item.campaign"
                                :is-visible="getToggleMenu(item.campaign.id)"
                                :url="getUrlDetails(item.campaign.id)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isLoadingMore" class="text-center py-4">
            <PageLoader :loading="loading" />
        </div>

        <div class="BrandResultBg py-40 md:py-64">
            <div class="container">
                <div class="BrandResultBgInfo">
                    <h3>FÅ FLERE TIL AT INTERAGERE MED DIT BRAND</h3>
                    <h4>BLIV KLOGERE PÅ VERDENSMÅLENE OG PÅ BETTERHYPE</h4>
                    <a :href="`/school`" class="btn text-wrap">Gå til betterhype-akademiet</a>
                </div>
            </div>
        </div>
        <PageLoader :loading="loading" />
    </div>
</template>

<style type="text/less" lang="less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';
@import '~dashboard-less/spark/components/Tabs';

.list-result {
    &:before {
        content: '';
        width: 60%;
        height: 93px;
        background: #1825d8;
        clip-path: polygon(0 0, 100% 0, 100% 50%, 2% 20%);
        display: block;
        position: absolute;
        top: -1px;
        right: 0;
    }
}
.brand-head {
    &:after {
        content: '';
        width: 85%;
        height: 60px;
        background: #ffffff;
        clip-path: polygon(0 0, 100% 0, 94% 30%, 0% 100%);
        display: block;
        position: absolute;
        top: calc(100% - 1px);
        left: 4rem;
    }
}
.BrandResultBg {
    position: relative;
    background-image: url('/img/bg-transfer.png');
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 400px;
    &:before {
        content: '';
        width: 55%;
        height: 93px;
        background: #ffffff;
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0 47%);
        display: block;
        position: absolute;
        top: -1px;
        right: 0;
    }

    .BrandResultBgInfo {
        text-align: center;
        h3 {
            // font: normal normal 900 150px/150px Brandon Grotesque;
            font-size: 8rem;
            font-weight: 900;
            letter-spacing: 0px;
            color: #ffffff;
            text-transform: uppercase;
            font-style: normal;
            line-height: normal;
            margin-bottom: 40px;
        }
        h4 {
            // font: normal normal 900 70px/90px Brandon Grotesque;
            font-weight: 900;
            font-size: 4rem;
            letter-spacing: 0px;
            color: #ffffff;
            text-transform: uppercase;
            margin-bottom: 40px;
        }
        .btn {
            background: #ff00a8;
            color: #ffffff;
            text-transform: uppercase;
            letter-spacing: 5.4px;
            text-shadow: 1px 1px 0px #00000080;
            padding: 10px 30px;
            font-size: 18px;
            border-radius: 0;
        }
    }
}
.BrandResult {
    .PageHeader {
        .PageHeader__title * {
            color: #000000;
            font-style: normal;

            .text-black {
                font-style: normal;
                color: #000000 !important;
                font-weight: 900;
                font-size: 30px;
            }
        }
    }
}
.inviter-section {
    h3 {
        font-size: 22px;
        font-weight: 900;
        letter-spacing: 2.2px;
        color: #1825d8;
        text-transform: uppercase;
        margin-bottom: 15px;
    }
    p {
        text-align: center;
        font-size: 16px;
        letter-spacing: 0.8px;
        color: #1825d8;
        margin-bottom: 30px;
    }
    button {
        padding: 10px 20px;
        background: #fc0403;
        color: #ffffff;
        font-weight: 900;
        font-size: 16px;
        letter-spacing: 1.6px;
        color: #ffffff;
        text-transform: uppercase;
    }
}
@media (max-width: 767px) {
    .BrandResultBg {
        .BrandResultBgInfo {
            h3 {
                font-size: 2rem;
            }
            h4 {
                font-size: 1rem;
            }
        }
    }
}
</style>

<script type="text/babel">
import PageLoader from 'dashboard-js/components/utilities/PageLoader'
import BrandResultInfo from 'dashboard-js/components/brands/BrandResultInfo'
import BrandResultInfoDetail from 'dashboard-js/components/brands/BrandResultInfoDetail'
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'

export default {
    data: () => ({
        menuVisible: [],
        isError: false,
        currentPage: 1,
        hasMorePages: false,
        isLoadingMore: false,
        loadMoreUrl: null,
        items: []
    }),

    components: {
        PageLoader,
        BrandResultInfo,
        BrandResultInfoDetail,
    },

    mixins: [HasLoadingState],

    props: ['totalResult', 'resultItems', 'urls', 'nextPageUrl'],

    created() {
        this.menuVisible = [];
        this.loadMoreUrl = this.nextPageUrl;
        this.items = this.resultItems;
    },

    mounted() {
        // Initialize pagination state
        this.currentPage = this.resultItems.length > 0 ? 1 : 0
        this.hasMorePages = this.resultItems.length < this.totalResult

        // Add scroll event listener
        window.addEventListener('scroll', this.handleScroll)
    },

    beforeDestroy() {
        // Clean up event listener
        window.removeEventListener('scroll', this.handleScroll)
    },

    methods: {
        getTitle(campaign) {
            const filtered = this.menuVisible.filter(item => item.id === campaign.id);

            if (filtered.length > 0 && filtered[0].isToggled) {
                return 'TOTAL FOR INFLUENCER';
            }

            return `Total result from ${campaign.name}`;
        },

        toggleMenu(campaignId) {
            if (this.menuVisible.filter(item => item.id === campaignId).length > 0) {

                this.menuVisible = this.menuVisible.map(item => {
                    if (item.id === campaignId) {
                        item.isToggled = !item.isToggled;
                    }
                    return item;
                });

                return;
            }

            this.menuVisible.push({
                id: campaignId,
                isToggled: true
            });
        },

        getUrlDetails(campaignId) {
            return this.urls.campaignDetailsUrl[campaignId] || null;
        },

        getToggleMenu(campaignId) {
            return this.menuVisible.filter(item => item.id === campaignId).length > 0
                && this.menuVisible.filter(item => item.id === campaignId)[0].isToggled;
        },

        handleScroll() {
            // Check if we're near the bottom of the page
            const bottomOfWindow = Math.max(
                window.pageYOffset,
                document.documentElement.scrollTop,
                document.body.scrollTop
            ) + window.innerHeight;

            const heightOfDocument = document.documentElement.offsetHeight;

            // If we're near the bottom (within 5000px) and not currently loading
            if (bottomOfWindow > heightOfDocument - 5000
                && this.hasMorePages
                && !this.isLoadingMore
                && !this.loading
                && this.loadMoreUrl !== null
            ) {
                this.loadMore();
            }
        },

        loadMore() {
            this.isLoadingMore = true;

            // Increment page number
            this.currentPage++;

            if (this.loadMoreUrl === null) {
                this.isLoadingMore = false;
                return;
            }

            axios.get(this.loadMoreUrl)
                .then(response => {
                    if (response.data && response.data.resultItems) {
                        // Append new items to the existing list
                        this.items = [...this.items, ...response.data.resultItems];

                        this.urls.campaignDetailsUrl = {...this.urls.campaignDetailsUrl, ...response.data.campaignDetailsUrl};
                        // Check if we have more pages
                        this.hasMorePages = this.resultItems.length < this.totalResult;

                        // Update the URL for the next page
                        this.loadMoreUrl = response.data.nextPageUrl || null;
                    }
                })
                .catch(error => {
                    console.error('Failed to load more results:', error);
                    // Revert the page number on error
                    this.currentPage--;
                })
                .finally(() => {
                    this.isLoadingMore = false;
                });
        }
    },
}
</script>
